import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDashboardList,
  fetchDashboardChart,
  EditReportTime,
  AddReportTime,
  deleteTime,
  updateTimeStatus,toggleReportTimeActivation
} from "../actions/dashboardsAction";

export const dashboards = createSlice({
  name: "dashboards",
  initialState: {
    dashboards: null,
    dashboardChart: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded: false,
    isManageWardPage: false,
  },
  reducers: {
    userReset: (state) => {
      // state.dashboards= null;
      state.error = null;
    },

    resetPopup: (state) => {
      state.isLoader = false;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.error = null;
    },
    setManageWardPage: (state) => {
      state.isManageWardPage = true;
    },
    resetManageWardPage: (state) => {
      state.isManageWardPage = false;
    },
  },
  extraReducers: {
    [fetchDashboardList.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
      state.isRecordUpdated = false;
    },
    [fetchDashboardList.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.dashboards = payload?.data;
      state.isLoader = false;
    },
    [fetchDashboardList.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isRecordUpdated = false;
    },
    // Dashboard chart data
    [fetchDashboardChart.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
      state.isRecordUpdated = false;
    },
    [fetchDashboardChart.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.dashboardChart = payload?.data;
      state.isLoader = false;
    },
    [fetchDashboardChart.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isRecordUpdated = false;
    },
    [AddReportTime.pending]: (state, payload) => {
      state.error = null;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.isLoader = true;
    },
    [AddReportTime.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [AddReportTime.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isRecordUpdated = false;
    },

    [EditReportTime.pending]: (state, payload) => {
      state.error = null;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.isLoader = true;
    },
    [EditReportTime.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [EditReportTime.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isRecordUpdated = false;
    },

    [deleteTime.pending]: (state, payload) => {
      state.error = null;
      state.isRecordUpdated = false;
      state.isLoader = true;
    },
    [deleteTime.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isRecordUpdated = true;
      state.isLoader = false;
    },
    [deleteTime.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isRecordUpdated = false;
      state.isLoader = false;
    },
    [updateTimeStatus.pending]: (state, payload) => {
      state.error = null;
      state.isRecordUpdated = false;
      state.isLoader = true;
    },
    [updateTimeStatus.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isRecordUpdated = true;
      state.isLoader = false;
    },
    [updateTimeStatus.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isRecordUpdated = false;
      state.isLoader = false;
    },

    [toggleReportTimeActivation.pending]: (state, payload) => {
      state.error = null;
      state.isRecordUpdated = false;
      state.isLoader = true;
    },
    [toggleReportTimeActivation.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isRecordUpdated = true;
      state.isLoader = false;
    },
    [toggleReportTimeActivation.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isRecordUpdated = false;
      state.isLoader = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  userReset,
  userSort,
  userSearch,
  resetPopup,
  setManageWardPage,
  resetManageWardPage,
} = dashboards.actions;

export default dashboards.reducer;
